const logOut = () => {
  const wkt_key = localStorage.getItem("wkt_key");
  if (wkt_key) {
    fetch("https://api.waku-tan.jp/users/v1/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "",
        "x-authorization": `Bearer ${wkt_key}`,
      },
    }).then((response) => {
      if (response.status === 200 || response.status === 401) {
        localStorage.setItem("wkt_key", "");
        window.location.href = "/account/logout";
      }
    });
  } else window.location.href = "/account/logout";
};

const logOutButtons = document.querySelectorAll(".logoutBtn");
logOutButtons.forEach((button) => button.addEventListener("click", logOut));
